export const StatCard = {
  flow: 'y',
  gap: 'Z',
  padding: 'A B',
  background: 'surfaceBorder',
  border: '1px solid surfaceBorderStrong',
  borderRadius: 'Z',
  flex: '1',
  minWidth: 'E',

  StatValue: {
    tag: 'span',
    fontSize: 'B',
    fontWeight: '800',
    color: 'green',
  },
  StatLabel: {
    fontSize: 'Z',
    color: 'textSoft',
  },
}
